import FrequentTopic from "./FrequentTopic";

type CardProps = {
  title1: string;
  title2: string;
  topic: string;
};
const FrequentCard = ({ title1, title2, topic }: CardProps) => {
  return (
    <div className="w-[200px] xl:w-[250px] min-h-[70px] relative p-2 rounded-lg bg-[#0a0a0a] border border-stroke1 text-text3 text-[12px] xl:text-[14px] hover:border-stroke4 [&:hover>div>div]:bg-stroke4 [&:hover>div>div]:text-text3 hover:shadow-[0_0_8px_#3291ff] hover:bg-secondary4 transition duration-300 cursor-pointer">
      <div className="flex justify-between items-center gap-1">
        <h5 className="leading-5">{title1}</h5>
        <FrequentTopic topic={topic} />
      </div>
      <h5 className="mt-3">{title2}</h5>
    </div>
  );
};

export default FrequentCard;
